export const days = [
    { day: '--Please select--', value: '-1' },
    { day: 'Monday', value: '0' },
    { day: 'Tuesday', value: '1' },
    { day: 'Wednesday', value: '2' },
    { day: 'Thursday', value: '3' },
    { day: 'Friday', value: '4' }
];
